{
  "INTEGRATION_APPS": {
    "FETCHING": "Entegrasyonlar alınıyor",
    "NO_HOOK_CONFIGURED": "Bu hesapta yapılandırılmış {integrationId} entegrasyonu bulunmuyor.",
    "HEADER": "Uygulamalar",
    "STATUS": {
      "ENABLED": "Etkin",
      "DISABLED": "Devre dışı"
    },
    "CONFIGURE": "Yapılandır",
    "ADD_BUTTON": "Yeni bir bağlantı ekle",
    "DELETE": {
      "TITLE": {
        "INBOX": "Silme işlemini onayla",
        "ACCOUNT": "Bağlantıyı Kes"
      },
      "MESSAGE": {
        "INBOX": "Silmek istediğinizden emin misiniz?",
        "ACCOUNT": "Bağlantıyı kesmek istediğinizden emin misiniz?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Evet, Sil",
        "ACCOUNT": "Evet, Bağlantıyı Kes"
      },
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "API": {
        "SUCCESS_MESSAGE": "Bağlantı başarıyla silindi",
        "ERROR_MESSAGE": "Woot Sunucusuna bağlanılamadı, Lütfen daha sonra tekrar deneyin"
      }
    },
    "LIST": {
      "FETCHING": "Entegrasyon kancaları alınıyor",
      "INBOX": "Gelen Kutusu",
      "EDIT": {
        "BUTTON_TEXT": "Düzenle"
      },
      "DELETE": {
        "BUTTON_TEXT": "Sil"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Gelen Kutu Seç",
          "PLACEHOLDER": "Gelen Kutu Seç"
        },
        "SUBMIT": "Oluştur",
        "CANCEL": "İptal Et"
      },
      "API": {
        "SUCCESS_MESSAGE": "Entegrasyon kancası başarıyla eklendi",
        "ERROR_MESSAGE": "Woot Sunucusuna bağlanılamadı, Lütfen daha sonra tekrar deneyin"
      }
    },
    "EDIT": {
      "TITLE": "{name} Düzenle",
      "FORM": {
        "SUBMIT": "Güncelle",
        "CANCEL": "İptal"
      },
      "API": {
        "SUCCESS_MESSAGE": "Entegrasyon bağlantısı başarıyla güncellendi",
        "ERROR_MESSAGE": "Sohbet sunucusuna bağlanılamadı, lütfen daha sonra tekrar deneyin"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Bağlan"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Bağlantıyı Kes"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Fetch data from your own server and display it in the conversation sidebar. Returns HTML (shown in an iframe) or JSON (shown as a key/value list).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "E-postaları ve web sohbetlerini Daktela hesabınızla senkronize edin.",
      "RETINO": "Retino, iade ve talep yönetimine düzen getirir.",
      "MAILSHIP": "Mailship, depo ve sipariş karşılama yönetim sistemidir. Sipariş durumunu, takibini ve gönderim ayrıntılarını görüntüleyin.",
      "RAYNET": "Müşteri verilerinize erişmek için Raynet CRM hesabınızı bağlayın. Raynet kullanıcı adınız ve API jetonunuzla bir bağlantı ekleyin."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Bağlantıyı test et",
      "SUCCESS": "Bağlantı başarılı",
      "ERROR": "Bağlantı başarısız. Lütfen kimlik bilgilerinizi kontrol edin."
    }
  }
}
